/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { makeStyles } from '@material-ui/core/styles'
import { Button, IconButton, Grid, Typography, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { Edit, Save, Delete, Cancel, Add, Restore } from '@material-ui/icons'
import { MaterialReactTable } from 'material-react-table'
import { useTranslation } from 'react-i18next'
// import Dropdown from '../../../irmlib/src/components/Controls/Dropdown'
import { FlexByRow } from 'irmlib/styles'
import { getSlideoutInfo, getUser } from '../../../redux/global'
import { successToast, errorToast, validateDate } from '../../../common/functions'
import { Autocomplete } from '@mui/material'


const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    border: '1px solid #c9c9c9',
    borderRadius: 8,
    width: '100%',
    marginTop: theme.spacing(2),
  },
  fieldSelection: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}))

const LockedFieds = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { customerId, templateFields, templateFieldsOneil, disabled, selectedWmsInstance } = props
  // eslint-disable-next-line
  const [selectedFieldOneil, setSelectedFieldOneil] = useState('')
  const [selectedField, setSelectedField] = useState('')
  const [editingIndex, setEditingIndex] = useState(null)
  const [fieldValue, setFieldValue] = useState('')
  const [confirmDelete, setConfirmDelete] = useState(false) // Dialog state
  const [deleteIndex, setDeleteIndex] = useState(null) // Index of the row to delete
  const [lockedData, setData] = React.useState([])
  const [currentdocumentId, setDoc] = useState('')
  const { userName } = getSlideoutInfo()
  const { workerId } = getUser()
  const userNameWithId = `${workerId} (${userName})`
  useEffect(() => {
    setSelectedField('')
    setData([])
  }, [customerId])
  const handleAutocompleteChange = async(event, newValue) => {
    const value = newValue?.value || '' // Ensure value is correctly set
    setSelectedField(value)
    setSelectedFieldOneil(value)
    // eslint-disable-next-line
    const response = await gdeTransactions.getLockedFieldsListner(customerId, value, setData, setDoc)
  }
  const handleAddRow = () => {
    const newRow = { value: '', lastUpdatedBy: userNameWithId }
    setData((olddata) => [newRow, ...olddata])
    setEditingIndex(0)
    setFieldValue('')
  }

  const handleEditRow = (dataIndex) => {
    setEditingIndex(dataIndex)
    setFieldValue(lockedData[dataIndex]?.value)
  }

  const handleSaveRow = async (row) => {
    const updatedTableData = [...lockedData]

    try {
      // Validation: Check for empty values
      if (fieldValue === '') {
        errorToast({ message: t('toast.cantEmpty'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
        return
      }

      // Validation: Check for date format
      const fieldFormat = templateFieldsOneil[selectedField]?.customFormat
      if (fieldFormat === 'MM/DD/YYYY' || fieldFormat === 'DD/MM/YYYY') {
        if (!validateDate(fieldValue, fieldFormat)) {
          errorToast({ message: t('dataEntry.invalidDateFormat', { format: fieldFormat }), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
          return
        }
      }

      // Validation: Check for duplicates
      const isDuplicate = lockedData.some(
        (data, index) => data.value === fieldValue && index !== row.index
      )
      if (isDuplicate) {
        errorToast({ message: t('dataEntry.duplicateValue'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
        return
      }

      // Save the updated value in Table
      updatedTableData[row.index] = { value: fieldValue, lastUpdatedBy: userNameWithId, isActive: true }
      if (updatedTableData?.length === 1) {
        updatedTableData[(row.index) + 1] = { value: 'Other', lastUpdatedBy: userNameWithId, isActive: true }
      }
      setData(updatedTableData)

      // Save the updated value in Backend
      const date = new Date().toISOString()
      if (currentdocumentId) {
        await gdeTransactions.updateLocked(currentdocumentId, selectedField, date, updatedTableData)
        successToast({ message: t('toast.lockedFieldsSaved'), title: t('toast.success'), autoHideDuration: 3000, isBlocking: false })
      } else {
        const data = {
          createdTS: new Date().toISOString(),
          customer: customerId,
          [`${selectedField}`]: updatedTableData,
          templateField: selectedField,
          updatedTS: new Date().toISOString(),
        }
        await gdeTransactions.createSmartLockedFields(data)
      }

      setEditingIndex(null) // Reset editing mode
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error while saving row:', error)
      errorToast({ message: t('toast.saveRowError'), title: t('toast.error'), autoHideDuration: 3000, isBlocking: false })
    }
  }


  const setRefresh = () => {
    const newLockedData = lockedData.filter((item) => item.value !== '')
    setData(newLockedData)
  }

  const handleCancelEdit = () => {
    setEditingIndex(null)
    setFieldValue('')
    setRefresh()
  }

  const handleDeleteConfirmation = (dataIndex) => {
    setDeleteIndex(dataIndex)
    setConfirmDelete(true)
  }

  const handleDeleteRow = () => {
    const updatedTableData = [...lockedData]
    updatedTableData[deleteIndex] = { value: lockedData[deleteIndex].value, lastUpdatedBy: userNameWithId, isActive: !lockedData[deleteIndex].isActive }

    // const afterdeletion = updatedTableData.splice(deleteIndex, 1)
    setData(updatedTableData)
    // Save the updated value in Backend
    const date = new Date().toISOString()
    gdeTransactions.updateLocked(currentdocumentId, selectedField, date, updatedTableData)
    const messageKey = lockedData[deleteIndex]?.isActive ? 'toast.lockedFieldsDeleted' : 'toast.lockedFieldsRestored'
    successToast({
      message: t(messageKey),
      title: t('toast.success'),
      autoHideDuration: 3000,
      isBlocking: false,
    })
    
    setConfirmDelete(false)
    setDeleteIndex(null)
  }

  const handleCancelDelete = () => {
    setConfirmDelete(false)
    setDeleteIndex(null)
  }

  const columns = [
    {
      accessorKey: 'value',
      header: t('tableColumns.lockedFieldsval'),
      Cell: ({ row }) =>
        editingIndex === row.index
          ? (
            <TextField
              value={fieldValue}

              onChange={(e) => setFieldValue(e.target.value)}
              autoFocus={true}
            />
            )
          : (
            <Typography>{row.original.value}</Typography>
            ),
    },
    {
      accessorKey: 'lastUpdatedBy',
      header: t('tableColumns.updatedBy'),
    },
  ]

  columns.push(
    {
      accessorKey: 'actions',
      header: t('tableColumns.action'),
      Cell: (cell) => {
        const dataIndex = cell.row.index
        const row = cell.row
        return (
          <div className={classes.actions}>
            {editingIndex === dataIndex
              ? (
                <>
                  <IconButton
                    onClick={() => handleSaveRow(row)}
                    color="primary"
                  >
                    <Save />
                  </IconButton>
                  <IconButton onClick={handleCancelEdit} color="default">
                    <Cancel />
                  </IconButton>
                </>
                )
              : (
                <IconButton
                  onClick={() => handleEditRow(dataIndex)}
                  color="secondary"
                >
                  {row?.original?.isActive && row?.original?.value !== 'Other'
                    ? <Edit />
                    : null
                  }
                </IconButton>
                )}
            {editingIndex !== dataIndex && (
              <IconButton
                onClick={() => handleDeleteConfirmation(dataIndex)} // Open dialog
                color="error"
              >
                {row?.original?.isActive
                  ? <Delete />
                  : <Restore />
                }
              </IconButton>
            )}
          </div>
        )
      },
    }
  )
  const options = selectedWmsInstance === 'ONEIL'
    ? Object.keys(templateFieldsOneil).map((key) => ({
      label: templateFieldsOneil[key]?.label || key,
      value: key,
    }))
    : [
        ...Object.keys(templateFields).map((key) => ({
          label: templateFields[key]?.label || key,
          value: key,
        })),
      ]
  return (
    <>
      <FlexByRow style={{ alignItems: 'center', gap: '16px' }}>
        {/* <Dropdown
          options={Object.keys(templateFields).map((key) => ({
            label: templateFields[key].label || key,
            value: key,
          }))}
          value={selectedField}
          onChange={handleDropdownChange}
          label="Template Field"
        /> */}
        <div style={!selectedWmsInstance ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
          <Autocomplete
            sx={{ width: 200 }}
            size="small"
            options={disabled ? [] : options}
            getOptionLabel={(option) => option.label}
            value={selectedField ? { label: selectedField, value: selectedField } : null}
            onChange={handleAutocompleteChange}
            renderInput={(params) => (
              <TextField {...params} label="Template Field" variant="outlined" fullWidth />
            )}
            disabled={disabled}
          />
        </div>
      </FlexByRow>
      <div className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddRow}
              disabled={!selectedField}
            >
              <Add />
              {t('tableColumns.addLockedRow')}
            </Button>
          </Grid>
          <Grid item xs={12}>
            <MaterialReactTable columns={columns} data={lockedData}
              muiTableHeadCellProps={{
                sx: {
                  color: '#58595B',
                  fontWeight: 'bold',
                },
              }}
              muiTableBodyRowProps={({ row, rowIndex }) => {
                return {
                  sx: {
                    backgroundColor: row?.original?.isActive === false ? '#E4f7ff' : 'white',
                  }
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
      {/* Confirmation Dialog */}
      <Dialog open={confirmDelete} onClose={handleCancelDelete}>
        <DialogTitle>{t('templates.confirm')}</DialogTitle>
        <DialogContent>
          <Typography>
            {lockedData[deleteIndex]?.isActive ? t('toast.confiemDeleteMsg') : t('toast.confirmEnableMsg')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="default">
            {t('dialogs.cancel')}
          </Button>
          <Button
            onClick={handleDeleteRow}
            color={lockedData[deleteIndex]?.isActive ? 'primary' : 'secondary'}
          >
            {lockedData[deleteIndex]?.isActive ? t('Search.deleteTemplate') : t('buttons.restore')}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  )
}

export default LockedFieds